import { IonCard } from '@ionic/react';
import '@ionic/react/css/ionic-swiper.css';
import React from 'react';
import TextHelper from '../../utils/TextHelper';
import './Cards.scss';

export default function ProcessGoalCard(props: { goal: any, isTopicPage?: boolean, gradient?: string }) {
  const { goal, isTopicPage, gradient } = props;
  // eslint-disable-next-line
  const iconPath = require(`../../assets/goals/${goal.icon}`);

  return (
    <IonCard className="card-container">
      <div className="card-content-padding">
        <div className="card-process-goal-circle" style={{ background: isTopicPage ? `linear-gradient(135deg, ${gradient})` : goal.color }}>
          <img
            src={iconPath}
            alt=""
            style={{ width: '32px', height: '32px' }}
          />
        </div>
        <div className="card-title">
          {TextHelper.stripHTML(goal?.name)}
        </div>
        {goal.description
          ? (
            <div className="card-description">
              {`${TextHelper.stripHTML(goal.description)?.substring(0, 44)}...`}
            </div>
          ) : null}
      </div>
    </IonCard>
  );
}

ProcessGoalCard.defaultProps = {
  isTopicPage: false,
  gradient: '',
};
